import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const verifyUserIsProvisionedSuccess = createAction(
  '[Payment Link Landing Component - Permission] Verify User Is Provisioned Success',
);

export const verifyUserIsProvisionedError = createAction(
  '[Payment Link Landing Component - Permission] Verify User Is Provisioned Error',
  props<{ error: HttpErrorResponse }>(),
);
